"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import CarrierTypeAhead from "../carrier_typeahead";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
function carrierFromProps(props) {
  return props.carrier.id ? props.carrier : null;
}
function stateFromProps(props) {
  return {
    carrier_id: props.carrier ? props.carrier.id : void 0,
    carrier: carrierFromProps(props),
    userSelectedCarrier: false
  };
}
function terms(state) {
  return _.object(
    _.reject(_.pairs(state), function(pair) {
      return _.first(pair) === "carrier";
    })
  );
}
function searchButton(props) {
  if (props.searching) {
    return /* @__PURE__ */ jsx("button", { disabled: true, className: "small", children: "Searching..." });
  } else {
    return /* @__PURE__ */ jsxs("span", { children: [
      /* @__PURE__ */ jsx("button", { type: "submit", className: "button--confirmation", children: "Search" }),
      " ",
      /* @__PURE__ */ jsx("span", { className: "load-search-form__cancel-or", children: "or " }),
      /* @__PURE__ */ jsx("a", { className: "load-search-form__cancel-link", onClick: props.onCancel, children: "cancel" })
    ] });
  }
}
function search(props, state, e) {
  if (e) e.preventDefault();
  props.onSearch(terms(state));
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", __spreadProps(__spreadValues({}, stateFromProps(this.props)), {
      advancedSearch: false
    }));
    // STATE
    //
    __publicField(this, "selectCarrier", (carrier) => {
      this.setState({
        carrier_id: carrier ? carrier.id : void 0,
        carrier,
        userSelectedCarrier: true
      });
    });
    __publicField(this, "toggleAdvancedFields", () => {
      this.setState((prevState) => ({
        advancedSearch: !prevState.advancedSearch
      }));
    });
    __publicField(this, "advancedFields", () => {
      if (this.state.advancedSearch) {
        return /* @__PURE__ */ jsxs("div", { className: "row", children: [
          /* @__PURE__ */ jsxs("div", { className: "large-5 columns", children: [
            /* @__PURE__ */ jsx("label", { children: "Start Ship Date" }),
            /* @__PURE__ */ jsx(
              "input",
              {
                type: "date",
                value: this.state.ship_start || "",
                onChange: (e) => this.setState({
                  ship_start: e.target.value
                })
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "large-5 columns", children: [
            /* @__PURE__ */ jsx("label", { children: "End Ship Date" }),
            /* @__PURE__ */ jsx(
              "input",
              {
                type: "date",
                value: this.state.ship_end || "",
                onChange: (e) => this.setState({
                  ship_end: e.target.value
                })
              }
            )
          ] })
        ] });
      }
    });
  }
  static getDerivedStateFromProps(props, state) {
    return state.userSelectedCarrier ? null : stateFromProps(props);
  }
  // RENDERING
  render() {
    return /* @__PURE__ */ jsx("div", { className: "import-detail__search ", children: /* @__PURE__ */ jsxs("form", { onSubmit: (e) => search(this.props, this.state, e), children: [
      /* @__PURE__ */ jsxs("div", { className: "row", children: [
        /* @__PURE__ */ jsxs("div", { className: "large-5 columns", children: [
          /* @__PURE__ */ jsx("label", { htmlFor: "id-or-reference", children: "ID or Reference" }),
          /* @__PURE__ */ jsx(
            ValueLinkTextDroppableInput,
            {
              id: "id-or-reference",
              type: "text",
              autoFocus: true,
              value: this.state.reference,
              onValueChange: (reference) => this.setState({ reference }),
              className: "mousetrap-allow-text"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "large-5 columns", children: [
          /* @__PURE__ */ jsx("label", { children: Account.carrierTerm() }),
          /* @__PURE__ */ jsx(
            CarrierTypeAhead,
            {
              carrier: this.state.carrier,
              onSelectCarrier: this.selectCarrier,
              onClearCarrier: this.selectCarrier
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-10 columns load-search-form__advanced-search-toggle", children: /* @__PURE__ */ jsx("p", { children: /* @__PURE__ */ jsx("a", { onClick: this.toggleAdvancedFields, children: "Advanced search" }) }) }) }),
      this.advancedFields(),
      /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "large-5 columns", children: searchButton(this.props) }) })
    ] }) });
  }
}
